import { StateSchema } from 'app/config/storeConfig/types';
import { Lead } from 'entities/Lead';
import { User } from 'entities/User';

export const getSelectedUser = (state: StateSchema): Nullable<User | Lead> => state.chooseUserModal.selectedUser;
